import { Navigate, useLocation } from "react-router-dom";
import useUserStoreV2 from "store/user-store-v2/useUserStoreV2";
import { LoginCheckBlocker } from "../LoginCheckBlocker";
import { useEmailAuth } from "hooks/useEmailAuth";
import { Blocker } from "./Blocker";
import { ROUTES } from "consts";
// import { EmailCheckBlocker } from "../EmailCheckBlocker";
import { useCheckViewPoint } from "hooks/useCheckViewPoint";
import EmailCheckBlocker from "v2/components/EmailCheckBlocker/ui";

export const AuthCheckBlocker = ({
  children,
  withCard = false,
}: {
  children: React.ReactNode;
  withCard?: boolean;
}) => {
  const { tgUserId, tgUserName, email, isCustodial } = useUserStoreV2();
  const { credential } = useEmailAuth();
  const accessToken = localStorage.getItem("accessToken");
  const isMobile = useCheckViewPoint({ to: "md" });

  return (
    <Blocker
      withCard={false}
      blockerConfigs={[
        {
          check: !!tgUserId && !!tgUserName && !!accessToken,
          fallback: <LoginCheckBlocker />,
          excludePaths: [ROUTES.explorer],
        },
        {
          check: isCustodial || (!!accessToken && !!email && !credential.isSessionExpired),
          fallback: <EmailCheckBlocker variant="init" />,
          excludePaths: [ROUTES.explorer],
        },
        {
          check: !localStorage.getItem("cachedUrl"),
          fallback: <NavigateToCachedUrl excludedPaths={[ROUTES.gated, ROUTES.explorer]} />,
        },
      ]}>
      {children}
    </Blocker>
  );
};

const NavigateToCachedUrl = ({ excludedPaths }: { excludedPaths: string[] }) => {
  const location = useLocation();
  const cachedUrl = localStorage.getItem("cachedUrl");
  localStorage.removeItem("cachedUrl");

  if (excludedPaths.includes(location.pathname)) {
    return <Navigate to={location.pathname} />;
  }

  return <Navigate to={cachedUrl ?? ROUTES.explorer} />;
};
